<div data-qa="bm-model-header" class="flex justify-between" [ngClass]="budgetForm.controls.isEditState.value ? 'h-[3.75rem]' : 'h-[2.75rem]'">
  <div class="flex items-center gap-0.46875">
    @if(budgetForm.controls.isEditState.value) {
      <app-input
        data-qa="bm-model-name"
        class="w-[35rem]"
        [title]="'Name'"
        [additionalClass]="budgetForm.controls.name.invalid ? 'error' : ''"
        [formControl]="budgetForm.controls.name">
      </app-input>
      <app-input
        data-qa="bm-total-commitment"
        class="w-[10rem]"
        [title]="'Total commitment'"
        [formControl]="budgetForm.controls.totalCommitment"
        [thousandSeparator]="','"
        [separator]="'separator.0'"
        [suffixFirstIcon]="budgetForm.controls.totalCommitment.disabled ? 'edit.svg' : 'apply.svg'"
        [suffixSecondIcon]="budgetForm.controls.totalCommitment.disabled ? '' : 'close.svg'"
        (suffixFirstIconEmitter)="changeCommitment(budgetForm, budgetForm.controls.totalCommitment.disabled ? BmTimelineAction.EDIT : BmTimelineAction.SAVE)"
        (suffixSecondIconEmitter)="changeCommitment(budgetForm, BmTimelineAction.CANCEL)">
      </app-input>
      <app-input
        data-qa="bm-year-numbers"
        class="w-[10rem]"
        [title]="'Fund term, years'"
        [formControl]="budgetForm.controls.yearsNumber"
        [separator]="'separator.0'"
        [additionalClass]="budgetForm.controls.yearsNumber.disabled ? 'disabled' : (budgetForm.controls.yearsNumber.hasError('max') ? 'error' : '')"
        [suffixFirstIcon]="budgetForm.controls.yearsNumber.disabled ? 'edit.svg' : (budgetForm.controls.yearsNumber.hasError('max') ? '' : 'apply.svg')"
        [suffixSecondIcon]="budgetForm.controls.yearsNumber.disabled ? '' : 'close.svg'"
        (suffixFirstIconEmitter)="changeModelTimeline(budgetForm.controls.yearsNumber.disabled ? BmTimelineAction.EDIT : BmTimelineAction.SAVE)"
        (suffixSecondIconEmitter)="changeModelTimeline(BmTimelineAction.CANCEL)">
      </app-input>
    } @else {
      <div class="flex items-center gap-[1.75rem]">
        <app-selector
          data-qa="bm-selector"
          class="w-[35rem]"
          [data]="selectorData"
          [selectedItem]="selectedItem"
          [selectedItemStyle]="modelSelectedItemStyle"
          [itemTextField]="'selectorText'"
          [textClass]="'main-8 bold600'"
          [field]="'name'"
          (itemEmitter)="changeModel($event)">
        </app-selector>
        <div class="flex items-center gap-0.9375">
          <div class="flex flex-col gap-0.15625">
            <span class="font-4 black-11">Total commitment</span>
            <span data-qa="bm-total-commitment" class="font-2 bold600">{{budgetForm.getRawValue().totalCommitment / 10E6}} M</span>
          </div>
          <div class="grey-vertical-line"></div>
          <div class="flex flex-col gap-0.15625">
            <span class="font-4 black-11">Fund term</span>
            <span data-qa="bm-fund-term-years" class="font-2 bold600">{{budgetForm.getRawValue().yearsNumber}} years</span>
          </div>
        </div>
      </div>
    }
  </div>
  <div class="flex items-center gap-0.46875">
    @if(budgetForm.value.isEditState) {
      <app-button
        *ngIf="selectorData.length"
        data-qa="bm-bttn-cancel"
        [size]="'small'"
        (buttonClick)="buttonClicked(BmButtons.CANCEL)">
        Cancel
      </app-button>
      <app-button
        data-qa="bm-bttn-save"
        [type]="'accent'"
        [size]="'small'"
        [disabled]="budgetForm.invalid"
        (click)="budgetForm.getRawValue().uuid ? buttonClicked(BmButtons.UPDATE) : buttonClicked(BmButtons.CREATE)">
        Save
      </app-button>
    }
    @else {
      <div class="flex items-center content-center gap-0.46875">

        <app-button
          data-qa="bm-bttn-actions-delete"
          [size]="'small'"
          [type]="'grey-white'"
          [iconName]="'delete.svg'"
          (buttonClick)="buttonClicked(BmButtons.DELETE)">
          Delete
        </app-button>

        <app-button
          data-qa="bm-bttn-actions-duplicate"
          [size]="'small'"
          [type]="'grey-white'"
          [iconName]="'copy.svg'"
          (buttonClick)="buttonClicked(BmButtons.DUPLICATE)">
          Duplicate
        </app-button>

        <app-button
          data-qa="bm-bttn-edit"
          [size]="'small'"
          [type]="'grey-accent'"
          [iconName]="'edit.svg'"
          (buttonClick)="buttonClicked(BmButtons.EDIT)">
          Edit
        </app-button>

        <app-button
          data-qa="bm-bttn-new-model"
          [type]="'accent'"
          [size]="'small'"
          [iconName]="'plus.svg'"
          (buttonClick)="buttonClicked(BmButtons.ADD_NEW_MODEL)">
          New model
        </app-button>
      </div>
    }
  </div>
</div>

<app-modal-dialog
  *ngIf="show.modalThinkTwice"
  data-qa="bm-modal-delete"
  [header]="'Delete model'"
  [useStandardList]="false"
  [mainText]="deleteModalText"
  [addAdditionalText]="true"
  (isConfirmed)="confirmDeleteModel($event)">
</app-modal-dialog>

